import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from '../../../utils/baseQuery';

export const settingApi = createApi({
  reducerPath: 'settingApi',
  baseQuery,
  tagTypes: ['Chatbot', 'VoicebotConfig', 'ProviderKeyStatus', 'CSAT', 'TenantConfig'],
  endpoints: (builder) => ({}),
});
